import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { IconButton, Chip, CircularProgress, Tooltip, LinearProgress } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import RefreshIcon from "@material-ui/icons/Refresh";
import FileCopyIcon from "@material-ui/icons/FileCopy";
import api from "../../services/api";
import { toast } from "react-toastify";

const useStyles = makeStyles(() => ({
  panel: {
    width: 320, flexShrink: 0,
    background: "#F8FAFF",
    borderLeft: "1px solid #E8EDF5",
    display: "flex", flexDirection: "column",
    height: "100%", overflow: "hidden",
    fontFamily: "'Inter', system-ui, sans-serif",
  },
  header: {
    display: "flex", alignItems: "center", gap: 10, padding: "14px 16px",
    background: "linear-gradient(135deg, #0044CC 0%, #0066FF 60%, #6C5CE7 100%)",
    flexShrink: 0, position: "relative", overflow: "hidden",
  },
  headerBg: {
    position: "absolute", right: -20, top: -20, width: 100, height: 100,
    borderRadius: "50%", background: "rgba(255,255,255,0.07)", pointerEvents: "none",
  },
  headerIcon: {
    width: 32, height: 32, borderRadius: 10,
    background: "rgba(255,255,255,0.2)",
    display: "flex", alignItems: "center", justifyContent: "center", fontSize: "1rem",
    flexShrink: 0, zIndex: 1,
  },
  closeBtn: { color: "rgba(255,255,255,0.8)", padding: 4, marginLeft: "auto", zIndex: 1 },
  body: {
    flex: 1, overflowY: "auto", padding: "14px",
    display: "flex", flexDirection: "column", gap: 12,
  },
  loadingWrap: {
    flex: 1, display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center", gap: 12, padding: 24,
  },
  emptyWrap: {
    flex: 1, display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center", gap: 10, padding: 24,
  },
  analyzeBtn: {
    borderRadius: 12, fontWeight: 700, fontSize: "0.82rem",
    background: "linear-gradient(135deg, #0066FF, #6C5CE7)", color: "#fff",
    border: "none", padding: "11px 24px", cursor: "pointer",
    boxShadow: "0 6px 20px rgba(0,102,255,0.3)", marginTop: 4,
    transition: "all 0.2s",
  },
  // TEMP CARD
  tempCard: {
    borderRadius: 16, padding: "16px",
    display: "flex", alignItems: "flex-start", gap: 14,
    border: "1.5px solid", position: "relative", overflow: "hidden",
    flexShrink: 0,
  },
  tempEmoji: { fontSize: "2rem", flexShrink: 0, marginTop: 2 },
  confBar: { height: 5, borderRadius: 3, marginTop: 8, background: "rgba(0,0,0,0.08)", overflow: "hidden" },
  confFill: { height: "100%", borderRadius: 3, transition: "width 0.8s ease" },
  // SECTION
  section: {
    background: "#fff", border: "1px solid #E8EDF5", borderRadius: 16,
    padding: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.04)",
  },
  sectionLabel: {
    fontSize: "0.62rem", fontWeight: 800, textTransform: "uppercase",
    letterSpacing: "0.7px", color: "#94A3B8", marginBottom: 6, display: "block",
  },
  // AÇÃO
  actionHeader: {
    display: "flex", alignItems: "center", gap: 10, marginBottom: 10,
  },
  actionIcon: {
    width: 36, height: 36, borderRadius: 10,
    background: "linear-gradient(135deg, #0066FF, #6C5CE7)",
    display: "flex", alignItems: "center", justifyContent: "center",
    fontSize: "1rem", flexShrink: 0,
    boxShadow: "0 4px 12px rgba(0,102,255,0.25)",
  },
  // MSG
  msgBox: {
    background: "linear-gradient(135deg, #EFF6FF, #F5F0FF)",
    border: "1px solid rgba(0,102,255,0.15)",
    borderRadius: 10, padding: "12px 38px 12px 14px",
    fontSize: "0.82rem", color: "#0A1628", lineHeight: 1.65,
    fontStyle: "italic", position: "relative", marginBottom: 12,
  },
  copyBtn: {
    position: "absolute", top: 6, right: 6, padding: 3,
    color: "#0066FF", background: "rgba(0,102,255,0.08)",
    borderRadius: 6,
  },
  // RAZÃO
  reasonBox: {
    background: "#FFFBEB", border: "1px solid rgba(245,158,11,0.2)",
    borderRadius: 10, padding: "10px 14px",
    fontSize: "0.78rem", color: "#78350F", lineHeight: 1.6,
  },
  // AÇÕES
  actionsRow: { display: "flex", flexWrap: "wrap", gap: 6, marginTop: 12 },
  actBtn: {
    borderRadius: 10, fontWeight: 700, fontSize: "0.75rem",
    border: "none", cursor: "pointer", padding: "9px 14px",
    transition: "all 0.15s", display: "flex", alignItems: "center", gap: 5,
  },
  // FOOTER
  footer: {
    display: "flex", gap: 8, padding: "10px 12px",
    borderTop: "1px solid #E8EDF5", flexShrink: 0,
    background: "#fff",
  },
  refreshBtn: {
    flex: 1, borderRadius: 10, fontWeight: 700, fontSize: "0.75rem",
    background: "linear-gradient(135deg, #EFF6FF, #F5F0FF)",
    color: "#0066FF", border: "1px solid rgba(0,102,255,0.2)",
    cursor: "pointer", padding: "8px",
    display: "flex", alignItems: "center", justifyContent: "center", gap: 4,
  },
  ignoreBtn: {
    borderRadius: 10, fontWeight: 700, fontSize: "0.75rem",
    background: "#F8FAFF", color: "#94A3B8",
    border: "1px solid #E8EDF5", cursor: "pointer", padding: "8px 14px",
  },
}));

const TEMP_CONFIG = {
  quente: { emoji: "🔥", label: "Lead Quente",  color: "#DC2626", bg: "#FFF5F5", border: "#FECACA", barColor: "#EF4444" },
  morno:  { emoji: "⚡", label: "Lead Morno",   color: "#D97706", bg: "#FFFBEB", border: "#FDE68A", barColor: "#F59E0B" },
  frio:   { emoji: "❄️", label: "Lead Frio",    color: "#2563EB", bg: "#EFF6FF", border: "#BFDBFE", barColor: "#3B82F6" },
};

const ACTION_CONFIG = {
  fazer_pergunta:        { icon: "❓", label: "Fazer pergunta",        color: "#0066FF" },
  aplicar_tag:           { icon: "🏷️", label: "Aplicar tag",           color: "#7C3AED" },
  enviar_audio:          { icon: "🎵", label: "Enviar áudio",          color: "#00A86B" },
  fazer_ligacao:         { icon: "📞", label: "Fazer ligação",         color: "#0066FF" },
  criar_followup:        { icon: "📅", label: "Criar follow-up",       color: "#F59E0B" },
  enviar_proposta:       { icon: "📋", label: "Enviar proposta",       color: "#7C3AED" },
  enviar_prova_social:   { icon: "⭐", label: "Prova social",          color: "#F59E0B" },
  convidar_para_reuniao: { icon: "🤝", label: "Agendar reunião",       color: "#00A86B" },
  transferir_humano:     { icon: "👤", label: "Transferir p/ humano",  color: "#EF4444" },
  encerrar_atendimento:  { icon: "✅", label: "Encerrar atendimento",  color: "#64748B" },
  marcar_temperatura:    { icon: "🌡️", label: "Marcar temperatura",    color: "#F59E0B" },
  qualificacao:          { icon: "🎯", label: "Qualificar lead",       color: "#0066FF" },
};

const MISSION_PROMPT = `Você é um assistente especialista em vendas via WhatsApp. Analise o histórico e retorne APENAS JSON válido sem markdown:
{"leadTemperature":"quente|morno|frio","currentMoment":"descrição objetiva do momento (máx 10 palavras)","suggestedAction":"fazer_pergunta|aplicar_tag|enviar_audio|fazer_ligacao|criar_followup|enviar_proposta|enviar_prova_social|convidar_para_reuniao|transferir_humano|encerrar_atendimento|marcar_temperatura|qualificacao","suggestedMessage":"mensagem pronta para enviar (natural, sem aspas)","reason":"motivo objetivo em 1 frase","recommendedTag":"nome da tag ou null","confidence":85}
REGRAS: retorne UMA ação. Sem contexto→fazer_pergunta. Lead sumido→criar_followup. APENAS JSON puro.`;

const ModoMissao = ({ ticket, messages, onClose, onUseMessage, onCreateFollowup }) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);
  const [analyzed, setAnalyzed] = useState(false);

  const analyze = async () => {
    setLoading(true);
    try {
      const { data: promptsData } = await api.get("/prompt");
      const firstPrompt = promptsData?.prompts?.[0];
      const recent = (messages || []).slice(-20);
      const history = recent.map(m => `${m.fromMe ? "VENDEDOR" : "LEAD"}: ${m.body || ""}`).join("\n");
      const context = `Contato: ${ticket?.contact?.name || "Lead"} | Ticket #${ticket?.id}\n\nCONVERSA:\n${history || "Sem mensagens ainda."}`;
      const { data: res } = await api.post("/prompt/test", {
        prompt: MISSION_PROMPT, message: context, history: [],
        model: firstPrompt?.model || "gpt-4o-mini", maxTokens: 400,
      });
      const clean = res.reply.replace(/```json|```/g, "").trim();
      setResult(JSON.parse(clean));
      setAnalyzed(true);
    } catch (err) {
      toast.error("Erro ao analisar. Tente novamente.");
    }
    setLoading(false);
  };

  const temp = result ? (TEMP_CONFIG[result.leadTemperature] || TEMP_CONFIG.morno) : null;
  const action = result ? (ACTION_CONFIG[result.suggestedAction] || ACTION_CONFIG.fazer_pergunta) : null;

  return (
    <div className={classes.panel}>
      {/* HEADER */}
      <div className={classes.header}>
        <div className={classes.headerBg} />
        <div className={classes.headerIcon}>🎯</div>
        <div style={{ zIndex: 1 }}>
          <div style={{ fontWeight: 800, fontSize: "0.88rem", color: "#fff", letterSpacing: "-0.2px" }}>Modo Missão</div>
          <div style={{ fontSize: "0.64rem", color: "rgba(255,255,255,0.7)", marginTop: 1 }}>IA Comercial • {ticket?.contact?.name || "Lead"}</div>
        </div>
        <IconButton size="small" className={classes.closeBtn} onClick={onClose}>
          <CloseIcon style={{ fontSize: 15 }} />
        </IconButton>
      </div>

      <div className={classes.body}>

        {/* LOADING */}
        {loading && (
          <div className={classes.loadingWrap}>
            <div style={{ fontSize: "2rem", animation: "pulse 1.5s infinite" }}>🧠</div>
            <CircularProgress size={28} style={{ color: "#0066FF" }} />
            <div style={{ fontSize: "0.78rem", color: "#64748b", textAlign: "center", lineHeight: 1.6 }}>
              Analisando a conversa...<br />
              <span style={{ fontSize: "0.7rem", opacity: 0.6 }}>Identificando o melhor próximo passo</span>
            </div>
          </div>
        )}

        {/* EMPTY */}
        {!loading && !analyzed && (
          <div className={classes.emptyWrap}>
            <div style={{ width: 64, height: 64, borderRadius: 20, background: "linear-gradient(135deg,rgba(0,102,255,0.1),rgba(108,92,231,0.1))", display: "flex", alignItems: "center", justifyContent: "center", fontSize: "2rem", marginBottom: 4 }}>🎯</div>
            <div style={{ fontWeight: 800, fontSize: "0.9rem", color: "#0A1628", textAlign: "center" }}>Pronto para analisar</div>
            <div style={{ fontSize: "0.76rem", color: "#94a3b8", textAlign: "center", lineHeight: 1.6 }}>
              A IA vai analisar a conversa e sugerir a ação comercial mais assertiva para este momento.
            </div>
            <button className={classes.analyzeBtn} onClick={analyze}>
              ⚡ Analisar conversa agora
            </button>
          </div>
        )}

        {/* RESULTADO */}
        {!loading && result && temp && action && (
          <>
            {/* TEMPERATURA */}
            <div className={classes.tempCard} style={{ background: temp.bg, borderColor: temp.border }}>
              <span className={classes.tempEmoji}>{temp.emoji}</span>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 800, fontSize: "0.9rem", color: temp.color }}>{temp.label}</div>
                <div style={{ fontSize: "0.76rem", color: temp.color, opacity: 0.8, marginTop: 3, lineHeight: 1.5 }}>
                  {result.currentMoment}
                </div>
                <div className={classes.confBar}>
                  <div className={classes.confFill} style={{ width: `${result.confidence}%`, background: temp.barColor }} />
                </div>
                <div style={{ fontSize: "0.65rem", color: "#94A3B8", marginTop: 4 }}>
                  Confiança: <strong style={{ color: temp.color }}>{result.confidence}%</strong>
                </div>
              </div>
            </div>

            {/* PRÓXIMA AÇÃO */}
            <div className={classes.section}>
              <span className={classes.sectionLabel}>⚡ Próxima ação recomendada</span>
              <div className={classes.actionHeader}>
                <div className={classes.actionIcon} style={{ background: `linear-gradient(135deg, ${action.color}, ${action.color}99)` }}>
                  {action.icon}
                </div>
                <div>
                  <div style={{ fontWeight: 800, fontSize: "0.9rem", color: "#0A1628" }}>{action.label}</div>
                  {result.recommendedTag && (
                    <div style={{ display: "flex", alignItems: "center", gap: 4, marginTop: 3 }}>
                      <span style={{ fontSize: "0.65rem", color: "#94A3B8" }}>Tag:</span>
                      <span style={{ fontSize: "0.66rem", fontWeight: 700, padding: "1px 7px", borderRadius: 6, background: "rgba(0,102,255,0.08)", color: "#0066FF", border: "1px solid rgba(0,102,255,0.15)" }}>
                        {result.recommendedTag}
                      </span>
                    </div>
                  )}
                </div>
              </div>

              {/* MENSAGEM */}
              {result.suggestedMessage && (
                <div className={classes.msgBox}>
                  {result.suggestedMessage}
                  <Tooltip title="Copiar mensagem">
                    <IconButton size="small" className={classes.copyBtn}
                      onClick={() => { navigator.clipboard.writeText(result.suggestedMessage); toast.success("Copiado!"); }}>
                      <FileCopyIcon style={{ fontSize: 11 }} />
                    </IconButton>
                  </Tooltip>
                </div>
              )}

              {/* MOTIVO */}
              <div className={classes.reasonBox}>
                <strong>💡 Por quê? </strong>{result.reason}
              </div>

              {/* BOTÕES */}
              <div className={classes.actionsRow}>
                {result.suggestedMessage && (
                  <button className={classes.actBtn}
                    style={{ background: "linear-gradient(135deg,#0066FF,#6C5CE7)", color: "#fff", boxShadow: "0 4px 12px rgba(0,102,255,0.3)", flex: 1, justifyContent: "center" }}
                    onClick={() => onUseMessage && onUseMessage(result.suggestedMessage)}>
                    ✏️ Usar mensagem
                  </button>
                )}
                {result.suggestedAction === "criar_followup" && (
                  <button className={classes.actBtn}
                    style={{ background: "#FFFBEB", color: "#D97706", border: "1px solid rgba(245,158,11,0.25)" }}
                    onClick={onCreateFollowup}>
                    📅 Follow-up
                  </button>
                )}
                {result.recommendedTag && (
                  <button className={classes.actBtn}
                    style={{ background: "rgba(0,102,255,0.06)", color: "#0066FF", border: "1px solid rgba(0,102,255,0.15)" }}
                    onClick={() => toast.info(`Aplique a tag "${result.recommendedTag}" manualmente`)}>
                    🏷️ Tag
                  </button>
                )}
              </div>
            </div>
          </>
        )}
      </div>

      {/* FOOTER */}
      {analyzed && !loading && (
        <div className={classes.footer}>
          <button className={classes.refreshBtn} onClick={analyze}>
            <RefreshIcon style={{ fontSize: 13 }} /> Nova análise
          </button>
          <button className={classes.ignoreBtn} onClick={() => { setResult(null); setAnalyzed(false); }}>
            Resetar
          </button>
        </div>
      )}
    </div>
  );
};

export default ModoMissao;
